module.exports = __webpack_public_path__ + "img/66-r.3a91de78.png";